import { apiRequest } from '../apiRequest'

const sendReport = (data) => apiRequest(`/issues/report/`).post(data)

export const strikesApi = {
  sendReport,
}
